export default "__VITE_ASSET__BR4Zys_S__"